import { Dispatch, FC, SetStateAction } from 'react';
import { GoogleMap, useJsApiLoader } from '@react-google-maps/api';
import { googleMapConfig, initCoordinates } from 'src/app-config';
import { Hr, Loading } from 'src/components/_commons';
import { hthMapStyle } from 'src/components/_commons/house-to-house';
import { useGetIsDarkMode, useGetIsMobile } from 'src/custom-hooks';

type propsType = {
    setMap: Dispatch<SetStateAction<google.maps.Map | null>>;
};

export const ConfigCreateHTHTerritoriesMap: FC<propsType> = ({ setMap }) => {
    const isDarkMode = useGetIsDarkMode();
    const isMobile = useGetIsMobile();
    const mapLoader = useJsApiLoader(googleMapConfig);

    return (
        <>
        <Hr classes={'my-5'} />
        <h5 className={`text-center my-4 ${isDarkMode ? 'text-white' : ''}`}>
            Establecer algún punto central del territorio de la congregación
        </h5>
        <h5 className={`text-center mb-5 ${isDarkMode ? 'text-white' : ''}`}>
            Este punto va a ser el inicial de cada territorio antes del trazado de las manzanas y también el de algunos mapas de actividades (el zoom que se use en este paso no importa)
        </h5>
        {mapLoader.isLoaded ?
            <div className={'position-relative'} style={{ marginBottom: isMobile ? '660px' : '' }}>
                <GoogleMap
                    center={initCoordinates}
                    id={googleMapConfig.id}
                    mapContainerClassName={isMobile ? 'position-absolute' : 'd-block m-auto'}
                    mapContainerStyle={{
                        height: isMobile ? '600px' : '500px',
                        width: isMobile ? '100%' : '90%'
                    }}
                    onLoad={mapInstance => setMap(mapInstance)}
                    options={{
                        disableDefaultUI: false,
                        fullscreenControl: false,
                        isFractionalZoomEnabled: true,
                        mapTypeControl: false,
                        minZoom: 8,
                        panControl: true,
                        streetViewControl: true,
                        styles: hthMapStyle,
                        zoom: 16,
                        zoomControl: true,
                        zoomControlOptions: { position: google.maps.ControlPosition.LEFT_BOTTOM }
                    }}
                >
                </GoogleMap>
            </div>
            :
            <Loading mt={'40px'} />
        }
        </>
    );
}
